'use strict'

import React, { useEffect, useRef } from 'react'
import FadeIn from 'react-fade-in'
import lottie from 'lottie-web'

import * as loaderData from './lottie-loader.json'

const Loader = () => {
  const lottieEl = useRef(null)
  useEffect(() => {
    if (lottieEl) {
      lottie.loadAnimation({
        container: lottieEl.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: loaderData.default
      })
    }
  }, [lottieEl])

  return (
    <FadeIn>
      <div className='loader fixed w-full h-full top-0 left-0 flex items-center justify-center'>
        <div className='absolute w-full h-full bg-gray-900 opacity-75' />
        <div className='bg-transparent w-11/12 max-w-full sm:max-w-md md:max-w-lg lg:max-w-xl mx-auto rounded-sm z-50 overflow-y-auto px-2 pt-3 pb-1 -mt-24'>
          <div
            id='lottie-loader'
            ref={lottieEl}
            style={{
              overflow: 'hidden',
              margin: '0 auto',
              outline: 'none'
            }}
          />
        </div>
      </div>
    </FadeIn>
  )
}

export default Loader
